import { BasicType } from "@easy-email-pro-core/constants";
import { ElementChildren, HeroElement } from "@easy-email-pro-core/typings";
import { BlockRenderer } from "../BlockRenderer";
import { isValidReactChildren } from "@easy-email-pro-core/utils/isValidReactChildren";
import React from "react";
import { RecursivePartial } from "@easy-email-pro-core/typings/helper";

export type HeroProps = RecursivePartial<HeroElement["attributes"]> & {
  idx?: string | null;
  children?: ElementChildren | HeroElement["children"];
  data?: HeroElement["data"];
};

export function Hero(props: HeroProps) {
  const { data, idx, children: propsChildren, ...rest } = props;

  const node: HeroElement = {
    type: BasicType.HERO,
    data: data || {},
    attributes: { ...rest },
    children: isValidReactChildren(propsChildren) ? [] : propsChildren || [],
  };

  return (
    <BlockRenderer
      idx={idx}
      node={node}
      children={isValidReactChildren(propsChildren) ? propsChildren : null}
    />
  );
}
